import { ICheckRescheduleEligibilityDTO } from 'shared/domain/dtos';
import { IRescheduleEligibilityRepository } from 'shared/domain/repositories';

export default class CheckRescheduleEligibilityUseCase {
  constructor(
    private rescheduleEligibilityRepository: IRescheduleEligibilityRepository,
  ) {}

  public async execute({ scheduleId }: ICheckRescheduleEligibilityDTO) {
    return this.rescheduleEligibilityRepository.findOne(scheduleId);
  }
}
